import styled from "styled-components";

const Bold = styled.b`
  font-weight: 500;
`;

export default Bold;
